import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function CreditCard(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "CreditCard", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40.656 7.34483H14.587c-2.3996 0-4.3448 1.94525-4.3448 4.34487v14.4827c0 2.3996 1.9452 4.3448 4.3448 4.3448h26.069c2.3996 0 4.3448-1.9452 4.3448-4.3448V11.6897c0-2.39962-1.9452-4.34487-4.3448-4.34487Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.5682 14.5861c.9998 0 1.8103-.8105 1.8103-1.8103s-.8105-1.8104-1.8103-1.8104c-.9999 0-1.8104.8106-1.8104 1.8104s.8105 1.8103 1.8104 1.8103Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.949 14.5861c.9998 0 1.8104-.8105 1.8104-1.8103s-.8106-1.8104-1.8104-1.8104-1.8103.8106-1.8103 1.8104.8105 1.8103 1.8103 1.8103Zm-16.2941-.7242h-4.3448c-.4 0-.7242.3242-.7242.7242v4.3448c0 .3999.3242.7241.7242.7241h4.3448c.3999 0 .7241-.3242.7241-.7241v-4.3448c0-.4-.3242-.7242-.7241-.7242Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.4138 17.4828H7.34483C4.94525 17.4828 3 19.428 3 21.8276v14.4827c0 2.3996 1.94525 4.3449 4.34483 4.3449H33.4138c2.3996 0 4.3448-1.9453 4.3448-4.3449V21.8276c0-2.3996-1.9452-4.3448-4.3448-4.3448Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M37.7586 21.8276H3v4.3448h34.7586v-4.3448Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M31.2408 34.862c1.1998 0 2.1724-.9726 2.1724-2.1724 0-1.1998-.9726-2.1724-2.1724-2.1724-1.1998 0-2.1724.9726-2.1724 2.1724 0 1.1998.9726 2.1724 2.1724 2.1724Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M26.897 34.862c1.1998 0 2.1724-.9726 2.1724-2.1724 0-1.1998-.9726-2.1724-2.1724-2.1724-1.1998 0-2.1724.9726-2.1724 2.1724 0 1.1998.9726 2.1724 2.1724 2.1724Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.5866 35.5861H7.34523c-.19205 0-.37624-.0762-.51204-.212-.1358-.1359-.2121-.32-.2121-.5121 0-.192.0763-.3762.2121-.512.1358-.1358.31999-.2121.51204-.2121h7.24137c.1921 0 .3763.0763.5121.2121.1358.1358.212.32.212.512 0 .1921-.0762.3762-.212.5121-.1358.1358-.32.212-.5121.212Zm5.7931 0h-2.8965c-.1921 0-.3763-.0762-.5121-.212-.1358-.1359-.2121-.32-.2121-.5121 0-.192.0763-.3762.2121-.512.1358-.1358.32-.2121.5121-.2121h2.8965c.1921 0 .3763.0763.5121.2121.1358.1358.2121.32.2121.512 0 .1921-.0763.3762-.2121.5121-.1358.1358-.32.212-.5121.212Zm-2.8965-2.8965H7.34523c-.19205 0-.37624-.0763-.51204-.2121-.1358-.1358-.2121-.32-.2121-.512 0-.1921.0763-.3763.2121-.5121.1358-.1358.31999-.2121.51204-.2121H17.4832c.192 0 .3762.0763.512.2121.1358.1358.2121.32.2121.5121 0 .192-.0763.3762-.2121.512-.1358.1358-.32.2121-.512.2121Z",
        fill: theme.vars.palette.secondary.dark
      }
    )
  ] });
}
CreditCard.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "CreditCard"
};
validateTidalLicense();
export {
  CreditCard
};
//# sourceMappingURL=CreditCard.js.map
